import {Injectable, OnDestroy} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {interval, Subscription} from 'rxjs';
import {AppAlertService} from './app-alert.service';
import {ParametersService} from './parameters.service';
import {UserService} from './user.service';
import {PopupResponse} from "../models";

@Injectable({
  providedIn: 'root'
})
export class PopupService implements OnDestroy {
  private lastUpdate: string | null = null;
  private popupIntervalSubscription: Subscription;

  constructor(
      private http: HttpClient,
      private appAlert: AppAlertService,
      private parameters: ParametersService,
      private user: UserService
  ) {}

  startPopupInterval(): void {
    if (this.parameters.selectedModuleHash === 0) return;

    this.fetchPopup();
    this.popupIntervalSubscription = interval(90000).subscribe(() => {
      this.fetchPopup();
    });
  }

  stopPopupInterval(): void {
    this.lastUpdate = null;
    if (this.popupIntervalSubscription) {
      this.popupIntervalSubscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.stopPopupInterval();
  }

    private fetchPopup(): void {
        const baseUrl = `/api/v1/users/${this.user.user_id}/modules/${this.parameters.selectedModuleHash}`;

        this.http.get<PopupResponse>(`${baseUrl}/update/popup/last_update/${this.lastUpdate}`, { observe: 'response' }).subscribe({
            next: (response) => {
                const url = response.url;

                if (this.parameters.selectedModuleHash !== 0 && url.includes(this.parameters.selectedModuleHash)) {
                    const responseBody = response.body;

                    this.lastUpdate = responseBody.lastUpdate;

                    if (responseBody.elements.length) {
                        responseBody.elements.forEach((popupData: any) => {
                            this.appAlert.showPopup(popupData);
                        });
                    }
                }
            },
        });
    }

  clearPopup(index: number): void {
    const currentElement = this.appAlert.popupElements[index];
    const data = JSON.stringify({ id: currentElement.id });
    const baseUrl = `/api/v1/users/${this.user.user_id}/modules/${currentElement.module.udid}`;

    this.http.post(`${baseUrl}/alarm_history`, data)
        .subscribe(() => {
          this.appAlert.closePopup(index);
        });
  }

  confirmPolicy(index: number): void {
    this.http.put('/api/v1/account/policy',{})
        .subscribe(() => {
          this.appAlert.closePopup(index);
        });
  }
}
